// import Chart from 'chart.js/auto';
// import ChartDataLabels from 'chartjs-plugin-datalabels';

import CountUp from './module/utils/_countUp'

// ロゴサイズ変更
if (document.getElementById('page-data')) {
  const setGoogleLogoSize = () => {
    const isSp = window.innerWidth <= 768

    document
      .querySelectorAll('.dataClient__review .ti-widget.ti-goog .ti-small-logo img[src*="logo.svg"]')
      .forEach((logo) => {
        if (isSp) {
          logo.style.setProperty('width', '93px', 'important')
          logo.style.setProperty('height', '30px', 'important')
        } else {
          logo.style.setProperty('width', '93px', 'important')
          logo.style.setProperty('height', '30px', 'important')
        }
      })
  }

  window.addEventListener('load', setGoogleLogoSize)
  window.addEventListener('resize', setGoogleLogoSize)

  document.querySelectorAll('.js-count-up').forEach((element) => {
    new CountUp(element)
  })
}
